/**
 * Currency formatter: always uses ISO code (BHD, USD, EUR…) — no localized
 * glyphs. BHD = 3 decimals (fils), USD/EUR/etc = 2.
 */
const DP_BY_CURRENCY: Record<string, number> = {
  BHD: 3, KWD: 3, OMR: 3,
  USD: 2, EUR: 2, GBP: 2, AED: 2, SAR: 2,
};

export function fmt(n: number | string, cur: string = 'BHD'): string {
  const code = (cur || 'BHD').toUpperCase();
  const dp = DP_BY_CURRENCY[code] ?? 2;
  const num = typeof n === 'string' ? Number(n) : n;
  const formatted = (Number.isFinite(num) ? num : 0).toLocaleString('en-US', {
    minimumFractionDigits: dp,
    maximumFractionDigits: dp,
  });
  return `${formatted} ${code}`;
}
